import React from 'react';
import { LinkProps } from './Link.types';
import { LinkAnchor } from './LinkComponents/LinkAnchor';
import { LinkNavLink } from './LinkComponents/LinkNavLink';

export const Link: React.FC<LinkProps> = ({
  children,
  className,
  variant = 'underline',
  size = 'default',
  showExternalIcon = false,
  showDocumentIcon = false,
  ariaLabel,
  tabIndex,
  testId = 'link',
  autoTestId,
  onClick,
  onKeyDown,
  disabled,
  ...rest
}) => {
  const commonProps = {
    ariaLabel,
    testId,
    variant,
    size,
    showExternalIcon,
    showDocumentIcon,
    className,
    tabIndex,
    children,
    autoTestId,
    onClick,
    onKeyDown,
    disabled,
  };

  switch (rest.as) {
    case 'link':
      return (
        <LinkAnchor
          {...commonProps}
          href={rest.href}
          target={rest.target}
          disableWcagAttributes={rest.disableWcagAttributes}
        />
      );

    case 'navlink':
      return (
        <LinkNavLink
          {...commonProps}
          to={rest.to}
          routeState={rest.routeState}
        />
      );

    default:
      return null;
  }
};
